/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { IProductRefinerHierarchy } from '@msdyn365-commerce/commerce-entities';
import { IActionContext } from '@msdyn365-commerce/core';
import { IQueryResultSettings, ProductRefiner, ProductSearchCriteria } from '@msdyn365-commerce/retail-proxy';
import { getProductSearchRefinersAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
//mmx-feature: Hide issue date attribute --start
import { getIssueDateAttributeAsync } from './DataActionExtension.g';
//mmx-feature: Hide issue date attribute --end

/**
 * Uses Bulk refiner API to get refiners and child refiner values.
 * @param searchCriteria Product search criteria.
 * @param queryResultSettings
 * @param ctx Action context.
 */
export async function getProductRefinerHierarchy(
	searchCriteria: ProductSearchCriteria,
	queryResultSettings: IQueryResultSettings,
	ctx: IActionContext
): Promise<IProductRefinerHierarchy[]> {
	//mmx-feature: Hide issue date attribute --start
	var issueDateAttribute = await getIssueDateAttributeAsync( {callerContext: ctx} );
	//mmx-feature: Hide issue date attribute --end
	return getProductSearchRefinersAsync({ callerContext: ctx, queryResultSettings }, searchCriteria).then(
		(productRefiners: ProductRefiner[]) => {
			if (!productRefiners) {
				ctx.trace('[getRefinersByCriteriaAction] returned no refiners');
				return <IProductRefinerHierarchy[]>[];
			}

			//mmx-feature: Hide issue date attribute --start
			/*
			const result = (productRefiners || []).map((productRefiner: ProductRefiner) => <IProductRefinerHierarchy>productRefiner);
			*/
			const result = (productRefiners || []).map((productRefiner: ProductRefiner) => <IProductRefinerHierarchy>productRefiner)
				.filter(refiner => refiner.RecordId !== issueDateAttribute.Attribute);
			//mmx-feature: Hide issue date attribute --end

			if (result.length === 0) {
				ctx.trace('[getRefinersByCriteriaAction] returned no IProductRefinerHierarchy objects');
				return <IProductRefinerHierarchy[]>[];
			}

			return result;
		}
	);
}
